import { Store } from 'pinia';
import cloneDeep from 'lodash.clonedeep';

type PiniaCustomStore = Store<string, any, {}, {}>;

export function resetStore(store: PiniaCustomStore) {
  const initialState = cloneDeep(store.$state);
  store.$reset = () => store.$patch(cloneDeep(initialState));
}
